import classNames from 'classnames';
import styles from './CategoryCard.module.scss';
import Link from "next/link";
import Image from "next/image";

const CategoryCard = ({ category, index }) => {
  return (
    <Link
      href={`/products/used/search/${category.handle}`}
      key={`category--id-${index}`}
      prefetch={false}
    >
      <div className={styles.category__wrapper}>
        <Image width={394} height={221} src={category.image} />
        <div className={styles.category__wrapper__content}>
          <div>
            <h5>{category.name}</h5>
            <p>{category.count}</p>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default CategoryCard;
